import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import Image from 'next/image';
import { Table } from 'antd';
import useTranslation from 'next-translate/useTranslation';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { confirmAlert } from 'react-confirm-alert';

import { getListGameAction, handleUpdateShowLogin } from 'store/user';
import { checkJoinRoomApi } from '@libs/apis/room';

import useWindowDimensions from 'hooks/useWindowDimensions';
import { MAX_PLAYER } from 'configs/enums';
import { ASSETS_URL } from 'configs/constant';
import { openInNewTab } from '@utils/helpers/common';
import webStorage from '@utils/webStorage';
import { formatImage } from '@utils/helpers/logic/image';

import { updateUserApi } from '@libs/apis/user';
import { getMeAction } from 'store/auth';

import WarningModal from '@components/core/commons/WarningModal';
// import IntroduceModal from "@components/core/commons/IntroduceModal";

import background from '@public/images/bg.png';
import title from '@public/images/title.png';
import titleMobile from '@public/images/title-mobile.png';
import arrow from '@public/images/arrow.png';
import playNow from '@public/icons/play-now.svg';
import user from '@public/icons/user.svg';
import userInplay from '@public/icons/user-inplay.svg';
import userFull from '@public/icons/user-full.svg';

export default function Banner() {
  const MOBILE_WIDTH = 1024.01;
  // const LIMIT_INTRODUCE_POPUP_SHOW_PER_DAY = 2;

  const { t } = useTranslation('banner');
  const dimensions = useWindowDimensions();
  const dispatch = useDispatch();
  const router = useRouter();

  const token = webStorage.getToken();
  const isAuth = useSelector((state) => state?.authReducer?.isAuth);
  const isNewbieCoBeRich = useSelector(
    (state) => state?.authReducer?.user?.isNewbieCoBeRich,
  );
  const listGame = useSelector((state) => state?.userReducer?.listGame);

  const [visibleModal, setVisibleModal] = useState(false);
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [activeGame, setActiveGame] = useState({});
  const [listRoom, setListRoom] = useState([]);
  const [intervalId, setIntervalId] = useState(null);
  const [loading, setLoading] = useState(true);
  // const [showModal, setShowModal] = useState(false);
  const [useMobileColumns, setUseMobileColumns] = useState(false);

  useEffect(() => {
    if (router.query?.tab) {
      setActiveTab(Number(router.query?.tab));
    } else {
      setActiveTab(0);
    }
  }, [router.query?.tab]);

  // useEffect(() => {
  //   const cookiePopupStatus = webStorage.get(POPUP_STATUS);
  //   if (cookiePopupStatus < LIMIT_INTRODUCE_POPUP_SHOW_PER_DAY) {
  //     setShowModal(true);
  //     webStorage.set(POPUP_STATUS, cookiePopupStatus + 1, { expires: 1 });
  //   }
  // }, []);

  useEffect(() => {
    if (dimensions?.width <= MOBILE_WIDTH) {
      setUseMobileColumns(true);
    } else {
      setUseMobileColumns(false);
    }
  }, [dimensions?.width]);

  useEffect(() => {
    const data = {
      populate:
        'logo.file, thumbnail.file, iconPlayNow.file, background.file, tableBackground.file',
    };
    dispatch(getListGameAction(data));
  }, [dispatch]);

  useEffect(() => {
    if (listGame?.length > 0) {
      setActiveGame(listGame?.[activeTab]);
    }
  }, [activeTab, listGame]);

  useEffect(() => {
    if (activeGame?.endpointAPI) {
      setLoading(true);
      getListRoom(activeGame?.endpointAPI);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeGame?.endpointAPI]);

  const getListRoom = useCallback(
    (endpoint) => {
      if (endpoint) {
        if (intervalId) {
          clearInterval(intervalId);
        }
        axios
          .get(
            `${endpoint}?filter={"isAuto":true,"isAvailable":true}&limit=999`,
          )
          .then((res) => {
            setListRoom(res?.data?.data?.docs);
            setLoading(false);
          })
          .catch((err) => {
            console.log('err', err);
          });

        const interval = setInterval(() => {
          axios
            .get(
              `${endpoint}?filter={"isAuto":true,"isAvailable":true}&limit=999`,
            )
            .then((res) => {
              setListRoom(res?.data?.data?.docs);
              setLoading(false);
            })
            .catch((err) => {
              console.log('err', err);
            });
        }, 5000);

        setIntervalId(interval);
      }
    },
    [intervalId],
  );

  const columns = [
    {
      key: 'code',
      title: t('roomCode'),
      align: 'center',
      width: '15%',
      render: (_, record) => (
        <div className='roomCode'>{record?.code || 'A-XXXX'}</div>
      ),
    },
    {
      key: 'status',
      title: t('status'),
      align: 'center',
      width: '5%',
      render: () => <Image className='arrow' src={arrow} alt={arrow} />,
    },
    {
      key: 'description',
      title: t('description'),
      align: 'left',
      width: '30%',
      render: (_, record) => (
        <div className='description'>
          {record?.description ||
            'room description is this longgggggggggggggggggg'}
        </div>
      ),
    },
    {
      key: 'countPlayer',
      title: t('players'),
      align: 'center',
      width: '30%',
      render: (_, record) => renderPlayers(record),
    },
    {
      key: 'action',
      title: t('action'),
      width: '20%',
      align: 'center',
      render: (_, record) => (
        <button
          onClick={() =>
            checkMaxPlayersBeRich(record)
              ? () => {}
              : handleClickJoinBtn(record)
          }
          className={`action-button ${
            checkMaxPlayersBeRich(record) ? 'disabled' : ''
          }`}
        >
          {checkMaxPlayersBeRich(record) ? t('full') : t('join')}
        </button>
      ),
    },
  ];

  const columnsMobile = [
    {
      key: 'code',
      title: t('roomCode'),
      width: '47%',
      render: (_, record) => (
        <div className='room-title'>
          <div className='room-code'>{record?.code || 'A-XXXX'}</div>
          <div className='room-desc'>
            {record?.description ||
              'room description is this longgggggggggggggggggg'}
          </div>
        </div>
      ),
    },
    {
      key: 'status',
      title: t('status'),
      align: 'center',
      width: '5%',
      render: () => <Image className='arrow' src={arrow} alt={arrow} />,
    },
    {
      key: 'countPlayer',
      title: t('players'),
      align: 'center',
      width: '20%',
      render: (_, record) => renderPlayers(record),
    },
    {
      key: 'action',
      title: t('action'),
      width: '25%',
      align: 'center',
      render: (_, record) => (
        <button
          onClick={() =>
            checkMaxPlayersBeRich(record)
              ? () => {}
              : handleClickJoinBtn(record)
          }
          className={`action-button ${
            checkMaxPlayersBeRich(record) ? 'disabled' : ''
          }`}
        >
          {checkMaxPlayersBeRich(record) ? t('full') : t('join')}
        </button>
      ),
    },
  ];

  const checkMaxPlayersBeRich = (record) => {
    return record?.countPlayer >= MAX_PLAYER && !activeTab;
  };

  const joinRoomTutorial = () => {
    axios
      .get(
        // `http://localhost:3000/v1/be-rich-room/create-room-tutorial`,
        `${activeGame?.endpointAPI}/create-room-tutorial`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        if (res.data?.data?.beRichRoom) {
          startJoinGameProccess(res.data?.data?.beRichRoom, true);
        } else {
          alert('Có lỗi xảy ra');
        }
        // Cho nay can goi api udpate co isNewbie khong con nua
        setLoading(false);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const handleClickJoinBtn = (record) => {
    if (isAuth) {
      if (activeGame?.nameConst === 'BE_RICH') {
        if (isNewbieCoBeRich) {
          confirmAlert({
            closeOnClickOutside: true,
            closeOnEscape: true,
            title: t('areYouNew'),
            message: t('newbieOffer'),
            buttons: [
              {
                label: t('yesBtn'),
                onClick: () => {
                  joinRoomTutorial();
                },
              },
              {
                label: t('noBtn'),
                onClick: () => {
                  updateUserApi({ isNewbieCoBeRich: false })
                    .then(async () => {
                      await dispatch(getMeAction());
                      startJoinGameProccess(record, false);
                    })
                    .catch(() => {
                      startJoinGameProccess(record, false);
                    });
                },
              },
            ],
          });
        } else {
          startJoinGameProccess(record, false);
        }
      } else {
        startJoinGameProccess(record, false);
      }
    } else {
      handleShowLogin();
    }
  };

  const startJoinGameProccess = (record, isNewbieCoBeRich = false) => {
    checkJoinRoomApi({
      roomKey: record?.id,
      nameConst: activeGame?.nameConst,
    })
      .then((res) => {
        if (res?.data?.data?.canJoin) {
          // openInNewTab('http://localhost:3003', record, token, isNewbieCoBeRich);
          openInNewTab(activeGame?.playNowUrl, record, token, isNewbieCoBeRich);
        } else {
          setError(res?.data?.data?.errors?.[0]?.code);
          setVisibleModal(true);
        }
      })
      .catch((err) => console.log('=== err', err));
  };

  const renderPlayers = (record) => {
    const players = record?.countPlayer || 0;
    const playersArr = [];
    for (let index = 0; index < MAX_PLAYER; index++) {
      if (index < players) {
        playersArr.push(1);
      } else {
        playersArr.push(0);
      }
    }

    return (
      <>
        {!activeTab ? (
          <div className='players'>
            {playersArr?.map((item, index) => (
              <Image
                width={20}
                height={20}
                key={index}
                src={
                  players >= MAX_PLAYER ? userFull : item ? userInplay : user
                }
                alt='player'
              />
            ))}
          </div>
        ) : (
          <div className='players'>
            <Image width={20} height={20} src={userInplay} alt='player' />
            <p>x</p>
            <p className='players__count'>{players}</p>
          </div>
        )}
      </>
    );
  };

  const handleSetActiveTab = (index) => {
    setActiveTab(index);
  };

  const handleClickPlayNow = () => {
    if (isAuth) {
      const room = filterRoomForPlayNow(listRoom);
      checkJoinRoomApi({
        roomKey: room?.id,
        nameConst: activeGame?.nameConst,
      })
        .then((res) => {
          if (res?.data?.data?.canJoin) {
            openInNewTab(activeGame?.playNowUrl, room, token);
          } else {
            setError(res?.data?.data?.errors?.[0]?.code);
            setVisibleModal(true);
          }
        })
        .catch((err) => console.log('=== err', err));
    } else {
      handleShowLogin();
    }
  };

  const handleShowLogin = () => {
    dispatch(handleUpdateShowLogin(true));
  };

  const filterRoomForPlayNow = (listRoom) => {
    const inPlayRoom = listRoom?.filter((item) => item?.isAvailable);
    if (inPlayRoom?.length > 0) {
      for (let index = 0; index < inPlayRoom?.length; index++) {
        if (inPlayRoom?.[index]?.countPlayer < MAX_PLAYER) {
          return inPlayRoom?.[index];
        }
      }
    }
  };

  const handleCancelModal = () => {
    setVisibleModal(false);
    setError('');
  };

  return (
    <div className='banner'>
      <div className='banner__content'>
        <div className='banner__content__left'>
          <div className='banner__content__left__title'>
            <div className='banner__content__left__title--top'>khai mở</div>
            <div className='banner__content__left__title--bottom'>
              <Image
                src={
                  `${ASSETS_URL}/${formatImage(activeGame?.tableBackground)}` ||
                  title
                }
                alt='title'
                width={667}
                height={332}
              />
            </div>
            <div className='banner__content__left__title--bottom-mobile'>
              <Image
                src={
                  `${ASSETS_URL}/${formatImage(activeGame?.tableBackground)}` ||
                  titleMobile
                }
                alt='title'
                width={352}
                height={180}
              />
            </div>
          </div>
          <div className='banner__content__left__desc'>
            {activeGame?.description || 'mô tả'}
          </div>
          <button
            className='banner__content__left__button'
            onClick={() => handleClickPlayNow()}
            disabled={loading}
          >
            <Image
              src={
                `${ASSETS_URL}/${activeGame?.iconPlayNow?.[0]?.file?.file?.[0]}` ||
                playNow
              }
              alt='playNow'
              width={29}
              height={29}
            />
            {t('playNow')}
          </button>
        </div>
        <div className='banner__nav-mobile'>
          {listGame?.map((item, index) => (
            <div
              key={index}
              className={`banner__nav-mobile--item ${
                activeTab === index ? 'banner__nav-mobile--item-active' : ''
              }`}
              onClick={() => handleSetActiveTab(index)}
            >
              <Image
                src={`${ASSETS_URL}/${item?.thumbnail?.[0]?.file?.file?.[0]}`}
                alt={item?.nameConst}
                width={76.8}
                height={77.32}
              />
            </div>
          ))}
        </div>
        <div className='banner__content__right'>
          <div className='banner__content__right__tab-wrapper'>
            <div className='banner__content__right__tab'>
              {t('roomList', { count: listRoom?.length || 0 })}
            </div>
          </div>
          <Table
            rowKey='id'
            className='banner__content__right__table'
            columns={useMobileColumns ? columnsMobile : columns}
            dataSource={listRoom || []}
            pagination={false}
            scroll={{ y: 'calc(100vh - 323px)' }}
            loading={loading}
            sticky
          />
        </div>
      </div>
      <div className='banner__background'>
        <Image
          src={
            `${ASSETS_URL}/${formatImage(activeGame?.background)}` || background
          }
          alt='background'
          layout='fill'
          quality={100}
          priority={true}
          objectFit='cover'
        />
      </div>
      <div className='banner__nav'>
        {listGame?.map((item, index) => (
          <div
            key={index}
            className={`banner__nav--item ${
              activeTab === index ? 'banner__nav--item-active' : ''
            }`}
            onClick={() => handleSetActiveTab(index)}
          >
            <Image
              src={`${ASSETS_URL}/${item?.thumbnail?.[0]?.file?.file?.[0]}`}
              alt={item?.nameConst}
              width={96}
              height={96.65}
            />
          </div>
        ))}
      </div>
      {visibleModal && (
        <WarningModal
          visible={visibleModal}
          onCancel={handleCancelModal}
          error={error}
        />
      )}

      {/* {showModal && (
        <IntroduceModal
          visible={showModal}
          onCancel={() => setShowModal(!showModal)}
        />
      )} */}
    </div>
  );
}
